<template>
  <div>
    <vxe-toolbar class="mt-2">
      <template #tools>
        <!-- <download-excel v-if="groupCount === 1" ref="excel" :data="analysisExcelData" :fields="analysisExcelColumnMap" :name="`${$t('bill.text_118')}.xlsx`">
          <a-button><icon type="download" /></a-button>
        </download-excel> -->
        <a-button @click="download"><icon type="download" /></a-button>
      </template>
    </vxe-toolbar>
    <vxe-grid
      class="w-100 mt-2"
      border
      max-height="800"
      ref="analysisTable"
      :columns="tableData.columns"
      :data="tableDataList"
      show-header-overflow
      show-footer-overflow
      show-overflow
      auto-resize
      :span-method="rowspanMethod"
      :cell-style="cellStyle"
      :cell-class-name="cellClassName"
      :footer-cell-class-name="cellClassName"
      :footer-cell-style="footerCellStyle"
      :pager-config="tablePage"
      :show-footer="tableDataList.length"
      :footer-method="footerMethod"
      :sort-config="{sortMethod: sortMethod}"
      :scroll-x="{gt: 100}"
      @page-change="handlePageChange"
      @cell-click="handleCellClick"
      @footer-cell-click="handleFooterCellClick" />
  </div>
</template>

<script>
import XLSX from 'xlsx'
import currencyRequest from '@Bill/mixins/currencyRequest'
import { addDataToSheetAfterFormat } from '@/utils/xlsx'
import AnalysisesMixin from '../mixins/analysises'

export default {
  name: 'AnalysisesTable',
  components: {
  },
  mixins: [currencyRequest, AnalysisesMixin],
  props: {
    formData: {
      type: Object,
      require: true,
    },
    dataList: {
      type: Array,
      require: true,
    },
    tagGroupParams: Object,
    projectTagGroupParams: Object,
    instanceTagGroupParams: Object,
    isGoPage: Boolean,
  },
  computed: {
    sortData () {
      return this.getSortData(this.tableData.data)
    },
    tableDataList () {
      const { currentPage, pageSize } = this.tablePage
      return this.sortData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    },
    groupCount () {
      return this.formData.group.length
    },
  },
  methods: {
    handlePageChange (params) {
      const { $event, currentPage, pageSize } = params
      const { type } = $event
      if (type === 'size') {
        this.tablePage.pageSize = pageSize
        this.tablePage.currentPage = 1
      }
      if (type === 'current') {
        this.tablePage.currentPage = currentPage
      }
    },
    footerMethod () {
      return this.footerRow
    },
    handleCellClick ({ row, column }) {
      if (!this.isGoPage) return
      if (['name', 'name2', 'percent'].includes(column.property)) return
      const { property } = column
      const { rowType = '' } = row
      const ret = {}
      // 非维度列和总计占比列的数据列，使用数据列的时间
      if (!(['name', 'name2', 'percent'].includes(column.property) || ['all'].includes(column.property))) {
        const { data_type } = this.formData.date
        if (data_type === 'day') {
          ret.start_date = this.$moment(property).format('YYYY-MM-DD') + 'TZ'
          ret.end_date = ret.start_date
        } else {
          ret.start_date = this.$moment(property).startOf('month').format('YYYY-MM-DD') + 'TZ'
          ret.end_date = this.$moment(property).endOf('month').format('YYYY-MM-DD') + 'TZ'
        }
      }
      this.formData.group.map((groupKey, index) => {
        if (rowType === 'total') {
          if (index === 0) {
            if (groupKey === 'tag') {
              ret[groupKey] = {
                [this.tagGroupParams.tag_key]: [row[index ? `name${index + 1}` : 'name']],
              }
            } else if (groupKey === 'project_tag') {
              ret[groupKey] = {
                [this.projectTagGroupParams.project_tag_key]: [row[index ? `name${index + 1}` : 'name']],
              }
            } else if (groupKey === 'instance_tag') {
              ret[groupKey] = {
                [this.instanceTagGroupParams.instance_tag_key]: [row[index ? `name${index + 1}` : 'name']],
              }
            } else {
              ret[groupKey] = row[index ? `name${index + 1}` : 'name']
            }
          }
        } else {
          if (groupKey === 'tag') {
            if (index === 0) {
              ret[groupKey] = {
                [this.tagGroupParams.tag_key]: [row.name],
              }
            } else {
              let tagVal = {
                [this.tagGroupParams.tag_key1]: [row.name2],
              }
              if (ret[groupKey]) {
                tagVal = {
                  ...ret[groupKey],
                  ...tagVal,
                }
              }
              ret[groupKey] = tagVal
            }
          } else if (groupKey === 'project_tag') {
            if (index === 0) {
              ret[groupKey] = {
                [this.projectTagGroupParams.project_tag_key]: [row.name],
              }
            } else {
              let tagVal = {
                [this.projectTagGroupParams.project_tag_key1]: [row.name2],
              }
              if (ret[groupKey]) {
                tagVal = {
                  ...ret[groupKey],
                  ...tagVal,
                }
              }
              ret[groupKey] = tagVal
            }
          } else if (groupKey === 'instance_tag') {
            if (index === 0) {
              ret[groupKey] = {
                [this.instanceTagGroupParams.instance_tag_key]: [row.name],
              }
            } else {
              let tagVal = {
                [this.instanceTagGroupParams.instance_tag_key1]: [row.name2],
              }
              if (ret[groupKey]) {
                tagVal = {
                  ...ret[groupKey],
                  ...tagVal,
                }
              }
              ret[groupKey] = tagVal
            }
          } else {
            ret[groupKey] = row[index ? `name${index + 1}` : 'name']
          }
        }
      })
      this.$emit('goBillPage', ret)
    },
    handleFooterCellClick ({ items, column }) {
      if (!this.isGoPage) return
      if (['name', 'name2', 'percent'].includes(column.property)) return
      const { property } = column
      const ret = {}
      // 非维度列和总计占比列的数据列，使用数据列的时间
      if (!(['name', 'name2', 'percent'].includes(column.property) || ['all'].includes(column.property))) {
        const { data_type } = this.formData.date
        if (data_type === 'day') {
          ret.start_date = this.$moment(property).format('YYYY-MM-DD') + 'TZ'
          ret.end_date = ret.start_date
        } else {
          ret.start_date = this.$moment(property).startOf('month').format('YYYY-MM-DD') + 'TZ'
          ret.end_date = this.$moment(property).endOf('month').format('YYYY-MM-DD') + 'TZ'
        }
      }
      this.$emit('goBillPage', ret)
    },
    rowspanMethod ({ row, rowIndex, column, visibleData }) {
      const fields = ['name']
      const cellValue = row[column.property]
      if (this.groupCount > 1 && fields.includes(column.property)) {
        const prevRow = visibleData[rowIndex - 1]
        let nextRow = visibleData[rowIndex + 1]
        if (prevRow && prevRow[column.property] === cellValue) {
          return { rowspan: 0, colspan: 0 }
        } else {
          let countRowspan = 1
          while (nextRow && nextRow[column.property] === cellValue) {
            nextRow = visibleData[++countRowspan + rowIndex]
          }
          if (countRowspan > 1) {
            return { rowspan: countRowspan, colspan: 1 }
          }
        }
      }
    },
    cellClassName ({ column }) {
      if (!this.isGoPage) return ''
      if (!['name', 'name2', 'percent'].includes(column.property)) {
        return 'hover-change-color-cell'
      }
    },
    cellStyle ({ row, rowIndex, column }) {
      const ret = {}
      if (!this.isGoPage) return ret
      if (row.rowType === 'total') {
        ret.color = 'black'
      }
      if (!['name', 'name2', 'percent'].includes(column.property)) {
        ret.cursor = 'pointer'
      }
      return ret
    },
    footerCellStyle ({ row, rowIndex, column }) {
      const ret = {
        color: 'black',
      }
      if (column.property === 'name') {
        ret.textAlign = 'right'
        if (this.groupCount > 1) {
          ret.backgroundImage = 'none'
        }
      } else if (column.property === 'name2') {
        ret.color = 'transparent'
      } else if (column.property !== 'percent') {
        ret.backgroundSize = '1px 100%, 100% 0'
        if (this.isGoPage) {
          ret.cursor = 'pointer'
        }
      }
      return ret
    },
    sortMethod ({ data, column, property, order }) {
      const sortData = this.getSortData(this.tableData.data, property, order)
      const { currentPage, pageSize } = this.tablePage
      return sortData.slice((currentPage - 1) * pageSize, currentPage * pageSize)
    },
    download () {
      const data = this.exportParams.data
      const filename = `${this.$t('bill.text_118')}.xlsx`
      const ws_name = 'Sheet1'
      const wb = XLSX.utils.book_new()
      const ws = addDataToSheetAfterFormat({ data, ignoreColsIndex: this.groupCount === 1 ? [0] : [0, 1] })
      ws['!merges'] = this.exportParams.merges.filter(item => item.s.r !== item.e.r || item.s.c !== item.e.c)
      XLSX.utils.book_append_sheet(wb, ws, ws_name)
      XLSX.writeFile(wb, filename)
    },
  },
}
</script>
<style lang="less" scoped>
.vxe-pager--num-btn .is--active {
  color: var(--antd-wave-shadow-color)!important;
}
</style>
